<form [formGroup]="otpForm">
  <div class="form-group form-group--sm">
    <div class="custom-otp">
      <label>{{labelText}}</label>
      <div class="custom-otp__inputs otp-shell">
        @for (digit of otpBoxes; track $index; let i = $index) {
          <div class="form-control otp-box" [class.otp-box--active]="i === otpLength && otpLength < 6" aria-hidden="true">{{digit}}@if (i === otpLength && otpLength < 6) {<span class="otp-box__caret"></span>}</div>
        }
        <input #otpInput formControlName="otp" (input)="onInput($event)" (paste)="onPaste($event)" type="tel" maxlength="6" autofocus autocomplete="one-time-code" inputmode="numeric" [attr.aria-label]="labelText" class="otp-real">
      </div>
    </div>
  </div>

  @if (showResendCode) {
    <p>
      Didn't get a verification code?
      <a href="javascript:void(0);" (click)="resendOtp(0)">
        <strong>Resend Code</strong>
      </a>
    </p>
  }
  or
  <p>
    <a href="javascript:void(0);" (click)="resendOtp(1)"><strong>Send OTP</strong></a> via email {{mask}}  instead.
  </p>
</form>
